import { Card, Button, Collapse } from "react-bootstrap";
import { FiPlus } from "react-icons/fi";
import { useState } from "react";

// ICONS
import { FaClipboardList } from "react-icons/fa";
import { MdTrackChanges } from "react-icons/md";
import { FaTasks } from "react-icons/fa";
import { FaImage } from "react-icons/fa";

const ActivitySection = () => {
  const [open, setOpen] = useState(true);

  const activities = [
    {
      id: 1,
      user: "Andrew",
      text: "added a New Task",
      date: "15 May 2024, 6:53 PM",
      color: "blue",
      icon: <FaClipboardList />,
    },
    {
      id: 2,
      user: "Jermai",
      text: 'Moved task "Private chat module"',
      date: "15 May 2024, 6:53 PM",
      color: "yellow",
      icon: <MdTrackChanges />,
      status: ["Completed", "Inprogress"],
    },
    {
      id: 3,
      user: "Jermai",
      text: 'Created task "Private chat module"',
      date: "15 May 2024, 6:53 PM",
      color: "purple",
      icon: <FaTasks />,
    },
    {
      id: 4,
      user: "Hendry",
      text: 'Updated Image "logo.jpg"',
      date: "15 May 2024, 6:53 PM",
      color: "dark",
      icon: <FaImage />,
    },
  ];

  return (
    <Card className="custom-card">
      <Card.Body>

        {/* HEADER */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h6>Activity</h6>

          <div className="d-flex align-items-center gap-2">
            <Button className="btn-orange btn-sm">
              <FiPlus /> Add New
            </Button>

            <span
              className="accordion-icon"
              onClick={() => setOpen(!open)}
            >
              {open ? "⌃" : "⌄"}
            </span>
          </div>
        </div>

        {/* ACCORDION */}
        <Collapse in={open}>
          <div className="activity-list">

            {activities.map((item) => (
              <div className="activity-row" key={item.id}>

                {/* ICON + LINE */}
                <div className="timeline">
                  <div className={`circle ${item.color}`}>
                    {item.icon}
                  </div>
                  <div className="line"></div>
                </div>

                {/* CONTENT */}
                <div className="content">
                  <p>
                    <b>{item.user}</b> {item.text}
                  </p>
                  <small>{item.date}</small>

                  {item.status && (
                    <div className="status-box">
                      <span className="badge green">Completed</span>
                      <span className="badge purple">Inprogress</span>
                    </div>
                  )}
                </div>

              </div>
            ))}

          </div>
        </Collapse>

      </Card.Body>
      <style>
        {
          `/* Circle with icon */


.custom-card{
          border-radius:6px;
border:1px solid #e5e7eb;
background:#ffffff;
}
.circle {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
}

/* Colors */
.circle.blue {
  background: #3b82f6;
}

.circle.yellow {
  background: #facc15;
  color: #000; /* like design */
}

.circle.purple {
  background: #a855f7;
}

.circle.dark {
  background: #1f2937;
}
          `
        }
      </style>
    </Card>
  );
};

export default ActivitySection;